import { useDispatch } from "react-redux";

import { ToastItem, ToastTypeInfo, toastSlice } from "../slices/toastSlice";

export const useSetInfoToast = (): ((
  payload: Omit<ToastItem, "ts" | "type">
) => void) => {
  const dispatch = useDispatch();
  return (payload) => {
    const action = toastSlice.actions.set({
      ...payload,
      ts: Date.now(),
      type: ToastTypeInfo,
    });
    dispatch(action);
  };
};
